import { api, buildQueryParams, URLs } from '@/libs/api'
import type {
  ApiResponse,
  Store,
  StoreData,
  StoreListParams,
  Stores,
  StoresData,
} from '@/libs/interfaces'

export const storesApi = {
  create: async (payload: Partial<Stores>): Promise<Stores> => {
    return api
      .post<ApiResponse<Stores>>(URLs.Stores.create(payload.orgID || ''), payload)
      .then((response) => response.data.data)
  },
  getStores: async (orgID: string): Promise<Store[]> => {
    return await api
      .get<{ data: { stores: Store[] } }>(URLs.STORES(orgID))
      .then((response) => response?.data?.data?.stores)
  },
  byID: async (params: Stores): Promise<StoreData> => {
    return await api
      .get<StoreData>(URLs.Stores.byID(params?.orgID || '', params?.storeID || ''))
      .then((response) => response.data)
  },
  delete: async (payload: Partial<Stores>): Promise<Stores> => {
    return api
      .delete<Stores>(URLs.Stores.byID(payload?.orgID || '', payload?.storeID || ''))
      .then((response) => response.data)
  },
  list: async (params?: StoreListParams): Promise<Stores[]> => {
    const { orgID = '', ...queryParams } = params || {}
    const query = buildQueryParams(queryParams)
    return await api
      .get<ApiResponse<StoresData>>(URLs.Stores.list(orgID, query))
      .then((response) => response.data?.data?.stores || [])
  },
  update: async (payload: Partial<Store>) => {
    const { orgID, ...patchData } = payload
    return await api
      .patch(URLs.Stores.byID(orgID || '', payload.storeID || ''), patchData)
      .then((response) => response.data)
  },
}
